import { getFacetCategoryTree } from '~/composables/_next/facetGetters';
import { attraqtGetters } from '~/composables/attraqt/useAttraqtIntegration';
import type { SearchData } from '~/composables/attraqt/useAttraqtIntegration.types';
import type { FacetResultsData, FacetSearchResult, AgnosticCategoryTree } from '~/types/vsf/facet-results-data';

export interface SearchItemType {
  name: string;
  link: string | Object;
}

export interface SearchCardType extends SearchItemType {
  category: string;
  image: string;
}

export const parseCategory = (category: FacetSearchResult<FacetResultsData>): SearchItemType[] => {
  const rawItems = getFacetCategoryTree(category)?.items;

  const flatten = (arr: AgnosticCategoryTree[], level = 0) => {
    const newArr = arr?.reduce((acc, item) => {
      if (item.items) {
        acc = acc.concat(
          flatten(
            item.items.map((item) => ({ ...item, level: level + 1 })),
            level + 1,
          ),
        );
      }

      return acc;
    }, arr);

    return newArr;
  };

  if (!rawItems?.length) {
    return [];
  }

  const items = flatten(rawItems)
    .filter(
      (item) =>
        item.label?.toLowerCase().includes(category.input.phrase.toLowerCase()) ||
        item.slug?.toLowerCase().includes(category.input.phrase.toLowerCase()),
    )
    .sort((a, b) => {
      return (b.level || 0) - (a.level || 0);
    })
    .slice(0, 3)
    .map((item) => ({
      link: {
        name: 'products-slug',
        params: { slug: item.slug },
      },
      name: item.label,
    }));

  return items;
};

export const parseAttraqtResult = (attraqtResult: SearchData, getLink: Function): SearchCardType[] => {
  const rawItems = attraqtGetters.getItems(attraqtResult)?.filter((item) => item.product?.url);

  if (!rawItems?.length) {
    return [];
  }

  const items = rawItems.map((item) => ({
    link: getLink(item),
    name: attraqtGetters.getName(item),
    category: attraqtGetters.getCategory(item) || attraqtGetters.getCategories(item)[0],
    image: attraqtGetters.getCoverImage(item),
  }));

  return items;
};
